import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { IdleModal } from 'components/IdleModal/IdleModal'
import useIdleTimer from 'hooks/useIdleTimer'
import SubscriberForm from 'components/subscription/subscriberForm'
import { useAuthContext } from '../providers/AuthProvider'
import Layout from '../views/Layout/Layout'

const PrivateRoutes = () => {
  const { isAuthenticated, hasAuthParams, signinRedirectCallback, signinRedirect, logout } = useAuthContext()
  const [logged, setLogged] = useState<boolean>(isAuthenticated())
  const { prompted, remainingTime, closePrompt } = useIdleTimer(logout)
  const location = useLocation()
  const isLobby = location.pathname === '/lobby'
  
  useEffect(() => {
    const handleRedirect = async () => {
      try {
        if (hasAuthParams()) {
          await signinRedirectCallback()
          const redirectUri = localStorage.getItem('redirectUri')
          window.history.replaceState({}, document.title, redirectUri)
          setLogged(true)
        } else {
          console.error('ErrorHandler-redirectTo')
          signinRedirect()
        }
      } catch (error) {
        console.error( error )
      }
    }
    handleRedirect()
  }, [])

  // eslint-disable-next-line no-nested-ternary
  return logged && !isLobby ?
    <Layout>
      <Outlet />
      <IdleModal isOpen={prompted} onClose={closePrompt} remainingTime={remainingTime} closeSession={logout} />
    </Layout>
    : isLobby ? <SubscriberForm /> : null
}

export default PrivateRoutes
